import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Endpoint, EndpointService } from '../endpoints/';

@Injectable({
	providedIn: 'root'
})
export class UrlCheckService {
	constructor(private http: HttpClient, private endpointService: EndpointService) {}

	/**
	 *
	 * @param url has to be enclosed in double-quotes "https://www.zone5cloud.com"
	 * returns an object {valid: boolean, reachable: boolean }
	 *
	 */
	invalid(url: string): Observable<any> {
		const api = `${this.endpointService.url(Endpoint.urlValidate)}`;
		return new Observable<any>((observer) => {
			this.http.post<any>(api, url).subscribe(
				(result: any) => {
					observer.next(result);
					observer.complete();
				},
				(error: any) => {
					observer.next({ valid: false, reachable: false }); // is an error
					observer.complete();
				}
			);
		});
	}
}
